import VuexPersist from "vuex-persist";

const vuexPersist = new VuexPersist({
  key: "wolves",
  storage: localStorage,
  reducer: state => ({
    player: state.player
  })
});

export { vuexPersist };
export default vuexPersist.plugin;



// WEBPACK FOOTER //
// ./src/store/plugins/persist.js